import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import {FormattedMessage, useIntl} from 'react-intl';
import {Screens} from '../constants/screens.mjs';
import EmployeeResult from './EmployeeResult.jsx';
import {FlowSteps} from '../constants/flowSteps.mjs';
import {LoginFlowScreenPropTypes} from '../../../shapes/index.mjs';

const Search = ({changeScreen, disableNewProfiles, employees = [], loginFlowChanged, onEmployeeSelected, loadEmployees, processing}) => {
  const intl = useIntl();
  const cssBEM = 'search-screen';
  const [ searchValue, setSearchValue ] = useState('');
  const [ initiatedSearch, setInitiatedSearch ] = useState(false);

  const searchForEmployees = useRef(debounce(search => {
    loadEmployees(search);
    setInitiatedSearch(true);
  }, 1000));

  const searchValueChanged = event => {
    setInitiatedSearch(false);
    const searchValue = event.target.value || '';
    setSearchValue(searchValue);
    if(searchValue) {
      searchForEmployees.current(searchValue);
    }
  };

  const startNewProfile = () => {
    onEmployeeSelected({});
    loginFlowChanged(FlowSteps.PROFILE_SELECTED);
    changeScreen(Screens.EDIT);
  };

  const onProfileSelect = employee => {
    onEmployeeSelected(employee || {});
    loginFlowChanged(FlowSteps.PROFILE_SELECTED);
    if((employee.branches || []).length){
      changeScreen(Screens.LOGIN);
    }else{
      changeScreen(Screens.EDIT);
    }
  };

  const renderEmployeeResults = () => {
    const employeesRender = (employees || []).map(employee => {
      return <EmployeeResult
        key={employee.id}
        employee={employee}
        onClick={() => onProfileSelect(employee)}
      />;
    });

    const renderResults = () => {
      let render = null;
      if( initiatedSearch && searchValue && !processing && !employeesRender.length ) {
        render = <span className="no-results"><FormattedMessage id="employeeLogin.search.results.empty" tagName="label" /></span>;
      }else if( employeesRender.length ) {
        render = <><FormattedMessage id="employeeLogin.search.results.description" tagName="label"/><div>{ employeesRender }</div></>;
      }
      return render;
    };

    return <div className={`${cssBEM}__results`}>
      { renderResults() }
    </div>;
  };

  return <section className={cssBEM}>
    <div className={`${cssBEM}__search`}>
      <FormattedMessage id="employeeLogin.search.label" tagName="label"/>
      <input
        type="search"
        id="employeeLoginSearchBox"
        placeholder={intl.formatMessage({id: 'employeeLogin.search.placeholder'})}
        onChange={searchValueChanged}
      />
    </div>

    { searchValue && !processing ? renderEmployeeResults() : null }

    { disableNewProfiles ? null :
      <div className="screen-actions">
        <button className="screen-actions__btn screen-actions__btn--float-right" onClick={startNewProfile}>
          <FormattedMessage id="employeeLogin.create"/>
        </button>
      </div>
    }
  </section>;
};

Search.propTypes = {
  ...LoginFlowScreenPropTypes,
  disableNewProfiles: PropTypes.bool,
  employees: PropTypes.array,
  loadEmployees: PropTypes.func.isRequired,
  onEmployeeSelected: PropTypes.func.isRequired
};

export default Search;
